<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="
        !isEdit
          ? $t('system.brand.brand.addBrand')
          : $t('system.brand.brand.editBrand')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="form"
        :rules="rulesCenter"
        :model="formInfo"
        label-suffix="："
        label-position="right"
        label-width="auto"
      >
        <el-form-item
          :label="$t('system.brand.brand.selectIcon')"
          prop="brandIcon"
        >
          <div style="min-height: 156px">
            <el-upload
              ref="upload"
              action=""
              list-type="picture-card"
              name="file"
              class="logoImg"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.JPG,.JPEG,.PBG,.GIF,.BMP,.SVG"
              :headers="{ Authorization: token }"
              :auto-upload="false"
              :http-request="uploadFile"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList_logo"
              :on-change="handleChange"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
            >
              <div class="el-upload__text">
                {{ $t("system.brand.brand.selectIcon") }}
              </div>
            </el-upload>
          </div>
          <el-dialog :visible.sync="logoDialogVisible" append-to-body>
            <img width="100%" :src="imgUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item
          :label="$t('system.brand.brand.brandName')"
          prop="brandName"
        >
          <el-input
            v-model="formInfo.brandName"
            clearable
            :placeholder="$t('system.brand.brand.brandName')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('system.brand.brand.brandCode')"
          prop="brandCode"
        >
          <el-input
            v-model="formInfo.brandCode"
            clearable
            :placeholder="$t('system.brand.brand.brandCode')"
          />
        </el-form-item>
        <el-form-item :label="$t('system.brand.remark')" prop="remark">
          <el-input
            v-model="formInfo.remark"
            :rows="3"
            :autosize="{ minRows: 3, maxRows: 3 }"
            resize="none"
            :placeholder="$t('system.brand.remark')"
            type="textarea"
            :maxlength="500"
            :show-word-limit="true"
          />
        </el-form-item>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="closeDialog"
        >{{ $t("public.cancel") }}</el-button
      >
      <el-button v-waves type="primary" @click="handleSubmit">{{
        $t("public.define")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { createUrl, updateUrl, TYPENUMBER } from '@/api/system/carBrand'
export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
    imgUrl() {
      return this.imgChanged ?
        this.logoUrl :
        `${process.env.VUE_APP_BASEURL}/common/brand/icon/${this.formInfo.brandId}?r=${Math.random()}`
    }
  },
  data() {
    // 图标
    const validateBrandIcon = (rule, value, cb) => {
      if (!this.formInfo.brandIcon) return cb(new Error(this.$t('system.brand.brand.errorIcon')))
    }
    // 名称
    const validateBrandName = (rule, value, cb) => {
      if (!this.formInfo.brandName) return cb(new Error(this.$t('system.brand.brand.errorName')))
    }
    // 编码
    const validateBrandCode = (rule, value, cb) => {
      if (!this.formInfo.brandCode) return cb(new Error(this.$t('system.brand.brand.errorCode')))
    }
    return {
      formInfo: {},
      rulesCenter: {
        brandIcon: [
          { required: true, trigger: ['blur', 'change'], validator: validateBrandIcon }
        ],
        brandName: [
          { required: true, trigger: ['blur', 'change'], validator: validateBrandName }
        ],
        brandCode: [
          { required: true, trigger: ['blur', 'change'], validator: validateBrandCode }
        ]
      },
      fileList_logo: [],
      logoDialogVisible: false,
      logoUrl: '',
      imgChanged: false,
      formData: new FormData()
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
        if (this.data.brandId) {
          this.formInfo.brandIcon = true // 编辑时不替换图片就通过图片验证
          this.fileList_logo.push({
            url: this.imgUrl
          })
          this.$nextTick(() => {
            document.querySelector('.logoImg>.el-upload').style.display = 'none'
          })
        }

      }
    }
  },
  created() {
  },
  methods: {
    // 关闭
    closeDialog() {
      this.fileList_logo = []
      this.imgChanged = false
      this.$emit('update:visibles', false)
    },
    // 上传文件
    uploadFile(file) {
      this._appendData({ file: file.file })
    },
    // 文件改变
    handleChange(file) {
      this.imgChanged = true
      this.formInfo.brandIcon = file
      this.$refs['form'].validateField(['brandIcon'])
      document.querySelector('.logoImg>.el-upload').style.display = 'none'
    },
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList, parentClassName) {
      this.formInfo.brandIcon = ''
      document.querySelector('.logoImg>.el-upload').style.display = 'inline-block'
    },
    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList, parentClassName) {
      document.querySelector('.logoImg>.el-upload').style.display = 'inline-block'
    },
    // eslint-disable-next-line no-unused-vars
    handlePreview(file, urlName) {
      this.logoUrl = file.url
      this.logoDialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const issvg = file.type === 'image/svg+xml'
      const isbmp = file.type === 'image/bmp'
      const isgif = file.type === 'image/gif'
      if (!isJPG && !isPng && !issvg && !isbmp && !isgif) {
        this.$message.error(this.$t('shop.photo'))
        return false
      }
      return true
    },
    // 提交
    handleSubmit() {
      const formCheck = this.checkForm({
        formName: 'form',
        formList: ['brandIcon', 'brandName', 'brandCode']
      })
      if (!formCheck) return
      const { brandName, brandCode, brandId } = this.formInfo
      const remark = this.formInfo.remark === undefined ? '' : this.formInfo.remarks
      this._initFormData()
      this._appendData({
        name: brandName,
        code: brandCode,
        type: TYPENUMBER,
        remark
      })
      this.$refs.upload.submit()
      if (!this.isEdit) {
        this._createBrand(this.formData)
      } else {
        this._appendData({ id: brandId })
        this._updateBrand(this.formData)
      }
    },
    // 新增
    _createBrand(postData) {
      const headers = { 'Content-Type': 'multipart/form-data' }
      this.$http.post(createUrl, postData, headers).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateBrand(postData) {
      const headers = { 'Content-Type': 'multipart/form-data' }
      this.$http.post(updateUrl, postData, headers).then(({ data }) => {
        if (data.code === 0) {
          this.imgChanged = false
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    // 添加数据
    _appendData(data) {
      for (let key of Object.keys(data)) {
        this.formData.append(key, data[key])
      }
    },
    // 清空FormData
    _initFormData() {
      this.formData = null
      this.formData = new FormData()
    }
  }
}
</script>

<style lang="scss" scoped>
.logoImg {
  margin: 0;
}
</style>
